import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { UsersRound } from "lucide-react";
import { z } from "zod";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { ClientsTab } from "@/features/booking/modules/clients/clients-tab";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/trainees/")({
  // Same label as `route.tsx`: both resolve to /trainees, so the breadcrumb shows it once.
  loader: () => ({ crumb: m.booking_clients_page_title() }),
  validateSearch: z.object({ bookingId: z.string().optional() }),
  component: ClientsPage,
});

function ClientsPage() {
  const navigate = useNavigate();

  return (
    <PageShell
      icon={UsersRound}
      title={m.booking_clients_page_title()}
      description={m.booking_clients_page_description()}
    >
      <ClientsTab onOpenClient={(clientId) => void navigate({ to: "/trainees/$clientId", params: { clientId } })} />
    </PageShell>
  );
}
